import FinanceModal from "./debug-modals/FinanceModal";
import WinterWheelsModal from "./debug-modals/WinterWheelsModal";
import RequestCarInfoModal from "./debug-modals/CarInfoModal";
import type { ModalMapType } from "../../../../../../../common-deprecated/types/CommonTypes";
import type { AphModalIdsType } from "../../../../utils/modalConstants";
import {
    MODAL_DEBUG_FINANCE,
    MODAL_DEBUG_CAR_INFO,
    MODAL_FINANCE_CALCULATOR,
    MODAL_FINANCE_DISCLAIMER,
    MODAL_HIGHLIGHT_FEATURE,
    MODAL_INSURANCE_CALCULATOR,
    MODAL_INSURANCE_DISCLAIMER,
    MODAL_ORDER_CHECKOUT,
    MODAL_OTHER_GRADE,
    MODAL_FULLSCREEN_CAR_SPIN,
    MODAL_DEBUG_WINTER_WHEELS,
} from "../../../../utils/modalConstants";
import FinanceCalculatorModal from "./injected/FinanceCalculatorModal";
import FinanceDisclaimerModal from "./injected/FinanceDisclaimerModal";
import HighlightFeatureModal from "./HighlightFeatureModal";
import InsuranceCalculatorModal from "./injected/InsuranceCalculatorModal";
import InsuranceDisclaimerModal from "./injected/InsuranceDisclaimerModal";
import OrderCheckoutModal from "./OrderCheckoutModal";
import OtherGradeModal from "./availableInOtherGrades/OtherGradeModal";
import ErrorModal from "../../../../../shared-components/toyota/debug-modals/ErrorModal";
import FullScreenSpinModal from "./FullScreenSpinModal";
import { aemToyotaDebugModalMap } from "../../../../../../../common-deprecated/components/modals/aem/modals";
import { MODAL_ERRORS } from "../../../../../../../common-deprecated/utils/modalConstants";

export const aemToyotaAphModalMap: ModalMapType<AphModalIdsType> = {
    ...aemToyotaDebugModalMap,
    [MODAL_ORDER_CHECKOUT]: OrderCheckoutModal,
    [MODAL_FINANCE_CALCULATOR]: FinanceCalculatorModal,
    [MODAL_FINANCE_DISCLAIMER]: FinanceDisclaimerModal,
    [MODAL_INSURANCE_CALCULATOR]: InsuranceCalculatorModal,
    [MODAL_INSURANCE_DISCLAIMER]: InsuranceDisclaimerModal,
    [MODAL_DEBUG_FINANCE]: FinanceModal,
    [MODAL_HIGHLIGHT_FEATURE]: HighlightFeatureModal,
    [MODAL_OTHER_GRADE]: OtherGradeModal,
    [MODAL_DEBUG_CAR_INFO]: RequestCarInfoModal,
    [MODAL_FULLSCREEN_CAR_SPIN]: FullScreenSpinModal,
    [MODAL_ERRORS]: ErrorModal,
    [MODAL_DEBUG_WINTER_WHEELS]: WinterWheelsModal,
};
